import http from "./http.js";

export default {
  userGet(payload) {
    return http.get(`/userget/${payload.action}/${payload.id}`);
  },
  userPost(payload) {
    return http.post("/userpost", { payload });
  },
  userUpload(files) {
    return http.post("/userupload", files, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${files._boundary}`,
      },
    });
  },


};
 